// extracted by mini-css-extract-plugin
module.exports = {"secondaryMenuHeader":"_1Kpb8","menuItemBigChevron":"_231oY"};